/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros 
Descripcion:        Formulario para la web de seguros
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ         ANALISTA                  FECHA       MOTIVO
(@#)1-A   SOL 32929    Emanuel Guivar           01/08/2025   Cambios fase 2 - Seguros
(@#)2-A   SOL 33756    Emanuel Guivar           30/12/2025   Cambios fase 3 - Seguros desailiacion, siniestro y endosos
--------------------------------------------------------------------------------------------------------------
*/
import React, { Fragment, useRef, useEffect } from 'react';
import FormSection from './blocks/FormSection';
import InputLayout from './blocks/InputLayout';
import InputText from './form/InputText';
import InputSelect from './form/InputSelect';
import useFinancieraLogic from '../hooks/useFinancieraLogic';
import { MediosRespuesta } from '../data/FinancieraData';
import ResultModal from './blocks/ResultModal';
import './../css/cssPersonalizados.css'; 

interface FinancieraFormProps {
    sistem: string, 
    appUser: string, //(@#)2-A 
};

const FinancieraForm = (props: FinancieraFormProps) => {

   
    //const { inputs, names, handleChange, handleBlur, handleSeguroChange, handleCoberturaChange, handleEliminarSeguro, segurosSeleccionados, combos, handleSend, result, errors, handleCloseModal, archivos, subirArchivos } = useFinancieraLogic();   //(@#)2-A
    const { inputs, names, handleChange, handleBlur, handleSeguroChange, handleCoberturaChange, handleEliminarSeguro, segurosSeleccionados, combos, handleSend, result, errors, handleCloseModal, archivos, subirArchivos, eliminarArchivo } = useFinancieraLogic(props.appUser);  //(@#)2-A
    const { documentos, solicitudes, creditos, seguros, mediosDevo, respuesta, coberturas, departamentos, provincias, distritos, motivos, locales } = combos;  //(@#)2-A
    //const { documentos, solicitudes, creditos, seguros, mediosDevo, respuesta, coberturas, departamentos, provincias, distritos } = combos;  //(@#)1-A //(@#)2-A
    //const { documentos, solicitudes, creditos, seguros, coberturas, departamentos, provincias, distritos } = combos;  //(@#)1-A
   
    return (
        <form className="FinancieraForm">
            {/*<ResultModal result={result.response} sistem={props.sistem}  onClose={handleCloseModal} /> */} {/*(@#)2-A*/}
            <ResultModal result={result.response} sistem={props.sistem} appUser={props.appUser} onClose={handleCloseModal} />  {/*(@#)2-A*/}
            <FormSection title="Datos Personales">
                <InputLayout className="col-6 col-md-3" label="Nro. Documento Solicitante">
                    <div className="row no-gutters">
                        <div className="col-4">
                            <InputSelect name={names.tipoDocSol} value={inputs.tipoDocSol} feedback={errors.tipoDocSol} onChange={handleChange} onBlur={handleBlur} options={documentos} />
                        </div>
                        <div className="col-8">
                            <InputText name={names.numDocSol} value={inputs.numDocSol} feedback={errors.numDocSol} onChange={handleChange} onBlur={handleBlur} />
                        </div>
                    </div>
                </InputLayout>
                 <InputLayout className="col-6 col-md-3" label="Apellido Paterno">
                     <InputText name={names.apPaternoSol} value={inputs.apPaternoSol} feedback={errors.apPaternoSol} onChange={handleChange} onBlur={handleBlur} />
                 </InputLayout>
                 <InputLayout className="col-6 col-md-3" label="Apellido Materno">
                     <InputText name={names.apMaternoSol} value={inputs.apMaternoSol} feedback={errors.apMaternoSol} onChange={handleChange} onBlur={handleBlur} />
                 </InputLayout>
                 <InputLayout className="col-6 col-md-3" label="Nombres">
                     <InputText name={names.nombresSol} value={inputs.nombresSol} feedback={errors.nombresSol} onChange={handleChange} onBlur={handleBlur} />
                 </InputLayout>                
               
                <InputLayout className="col-6 col-md-3" label="Nro. Documento Titular">
                    <div className="row no-gutters">
                        <div className="col-4">
                            <InputSelect name={names.tipoDocTit} value={inputs.tipoDocTit} feedback={errors.tipoDocTit} onChange={handleChange} onBlur={handleBlur} options={documentos} />
                        </div>
                        <div className="col-8">
                            <InputText name={names.numDocTit} value={inputs.numDocTit} feedback={errors.numDocTit} onChange={handleChange} onBlur={handleBlur} />
                        </div>
                    </div>
                </InputLayout>
               
                <InputLayout className="col-6 col-md-3" label="Apellido Paterno">
                    <InputText name={names.apPaternoTit} value={inputs.apPaternoTit} feedback={errors.apPaternoTit} onChange={handleChange} onBlur={handleBlur} />
                </InputLayout>
                <InputLayout className="col-6 col-md-3" label="Apellido Materno">
                    <InputText name={names.apMaternoTit} value={inputs.apMaternoTit} feedback={errors.apMaternoTit} onChange={handleChange} onBlur={handleBlur} />
                </InputLayout>
                <InputLayout className="col-6 col-md-3" label="Nombres">
                    <InputText name={names.nombresTit} value={inputs.nombresTit} feedback={errors.nombresTit} onChange={handleChange} onBlur={handleBlur} />
                </InputLayout>
           
                <div className="w-100"></div>
                <InputLayout className="col-12 col-md-6" label="Dirección">
                    <InputText name={names.direccion} value={inputs.direccion} feedback={errors.direccion} onChange={handleChange} onBlur={handleBlur} ph="Calle / Av / Jr" />
                </InputLayout>
                <InputLayout className="col-12 col-md-6" label="&nbsp;">
                    <div className="form-row">
                        <div className="col">
                            <InputText name={names.direccionNro} value={inputs.direccionNro} feedback={errors.direccionNro} onChange={handleChange} onBlur={handleBlur} ph="Nro / Mz" />
                        </div>
                        <div className="col">
                            <InputText name={names.direccionLot} value={inputs.direccionLot} feedback={errors.direccionLot} onChange={handleChange} onBlur={handleBlur} ph="Lote" />
                        </div>
                        <div className="col">
                            <InputText name={names.direccionInt} value={inputs.direccionInt} feedback={errors.direccionInt} onChange={handleChange} onBlur={handleBlur} ph="Int / Dpto" />
                        </div>
                    </div>
                </InputLayout>
                <InputLayout className="col-6 col-md-3" label="Urbanización">
                    <InputText name={names.urbanizacion} value={inputs.urbanizacion} feedback={errors.urbanizacion} onChange={handleChange} onBlur={handleBlur} />
                </InputLayout>
                           
                <InputLayout className="col-12 col-md-3" label="Departamento">
                    <InputSelect name={names.departamento} value={inputs.departamento} feedback={errors.departamento} onChange={handleChange} onBlur={handleBlur} options={departamentos} addDefault/>
                 </InputLayout>
                 <InputLayout className="col-12 col-md-3" label="Provincia">
                    <InputSelect name={names.provincia} value={inputs.provincia} feedback={errors.provincia} onChange={handleChange} onBlur={handleBlur} options={provincias} addDefault />
                 </InputLayout>
                 <InputLayout className="col-12 col-md-3" label="Distrito">
                    <InputSelect name={names.distrito} value={inputs.distrito} feedback={errors.distrito} onChange={handleChange} onBlur={handleBlur} options={distritos} addDefault/>
                 </InputLayout>
              
                <InputLayout className="col-6 col-md-3" label="Número de Contacto"> 
                    <InputText name={names.telefono} value={inputs.telefono} feedback={errors.telefono} onChange={handleChange} onBlur={handleBlur} type="tel" />
                </InputLayout>
              
                <InputLayout className="col-12 col-md-6" label="Correo Electrónico">
                    <InputText name={names.correo} value={inputs.correo} feedback={errors.correo} onChange={handleChange} onBlur={handleBlur} type="email" />
                </InputLayout>
                <InputLayout className="col-12 col-md-3" label="Medio de Respuesta">
                    {/*<InputSelect name={names.medioResp} value={inputs.medioResp} feedback={errors.medioResp} onChange={handleChange} onBlur={handleBlur} options={MediosRespuesta} />*/}  {/*(@#)1-A*/}
                    <InputSelect name={names.medioResp} value={inputs.medioResp} feedback={errors.medioResp} onChange={handleChange} onBlur={handleBlur} options={respuesta} />  {/*(@#)1-A*/}
                </InputLayout>
                { /*(@#)2-A inicio*/}
                {inputs.medioResp === 'Recojo en tienda' &&
                    <Fragment>
                        <InputLayout className="col-12 col-md-3" label="Agencia">
                            <InputSelect name={names.local} value={inputs.local} feedback={errors.local} onChange={handleChange} onBlur={handleBlur} options={locales} addDefault />
                        </InputLayout>
                        <InputLayout className="col-12 col-md-6" label="Dirección Local">
                            <InputText name={names.direccionLoc} value={inputs.direccionLoc} feedback={errors.direccionLoc} onChange={() => { }} onBlur={handleBlur} />
                        </InputLayout>
                    </Fragment>
                }
                { /*(@#)2-A fin*/}  
                <InputLayout className="col-12 col-md-3" label="Tipo de Solicitud">
                    <InputSelect name={names.tipoSol} value={inputs.tipoSol} feedback={errors.tipoSol} onChange={handleChange} onBlur={handleBlur} options={solicitudes} addDefault />
                </InputLayout>  
                &nbsp;
               
            </FormSection>
           
            <FormSection title={`Datos del Seguro`}>
                { /*(@#)2-A inicio*/}            
                {/*
                <InputLayout className="col-12 col-md-6" label="Motivo"> 
                    <InputText name={names.motivoSol} value={inputs.motivoSol} feedback={errors.motivoSol} onChange={handleChange} onBlur={handleBlur} disabled={true} />
                </InputLayout>
                */}
                {inputs.tipoSol === "Desafiliacion de seguros" && 
                    <InputLayout className="col-12 col-md-6" label="Motivo">
                        <InputSelect name={names.motivoSol} value={inputs.motivoSol} feedback={errors.motivoSol} onChange={handleChange} onBlur={handleBlur} options={motivos} addDefault />
                    </InputLayout>
                }
                {inputs.motivoSol === "Otros" &&
                    <InputLayout className="col-12 col-md-6" label="Detalle">
                        <InputText name={names.detalleMotivoSol} value={inputs.detalleMotivoSol} feedback={errors.detalleMotivoSol} onChange={handleChange} onBlur={handleBlur} rows={1} max={50} />
                    </InputLayout>
                }
                { /*(@#)2-A fin*/}            
                <InputLayout className="col-12 col-md-6" label="Nro de Préstamo(s)">
                    <InputSelect name={names.prestamo} value={inputs.prestamo} feedback={errors.prestamo} onChange={handleChange} onBlur={handleBlur} options={creditos} addDefault />
                </InputLayout>
                { /*(@#)2-A inicio*/} 
                {inputs.tipoSol === "Desafiliacion de seguros" &&
                    <InputLayout className="col-12 col-md-6" label="Medio de devolución">
                        <InputSelect name={names.medioDevo} value={inputs.medioDevo} feedback={errors.medioDevo} onChange={handleChange} onBlur={handleBlur} options={mediosDevo} addDefault />
                    </InputLayout>
                }
                { /*(@#)1-A inicio*/} 
                {/* 
                    <InputLayout className="col-12 col-md-6" label="Medio de devolución">
                        <InputSelect name={names.medioDevo} value={inputs.medioDevo} feedback={errors.medioDevo} onChange={handleChange} onBlur={handleBlur} options={mediosDevo} addDefault />
                    </InputLayout>
                    */}
                { /*(@#)2-A fin*/} 
                {inputs.medioDevo === "Devolucion a traves de una cuenta de ahorros de Efectiva" && mediosDevo.length > 0 &&
                    <InputLayout className="col-12 col-md-6" label="&nbsp;">
                        <div className="form-row">
                            <div className="col">
                                <InputText name={names.nroCuenta} value={inputs.nroCuenta} feedback={errors.nroCuenta} onChange={handleChange} onBlur={handleBlur} ph="Nro. Cuenta Ahorros de Efectiva" />
                                <a href="https://www.efectiva.com.pe/ahorros/cuenta-de-ahorros/" target="_blank" rel="noopener noreferrer" className="form-text text-muted" > ¿Aún no tienes una cuenta ahorro Efectiva? Ábrela aquí </a>
                            </div>                            
                        </div>
                    </InputLayout>
                }
                { /*(@#)1-A fin*/}
                <InputLayout className="col-12 col-md-6" label="Seguro(s)">
                    <InputSelect name={names.seguro} value={inputs.seguro} feedback={errors.seguro} onChange={handleSeguroChange} onBlur={handleBlur} options={seguros} addDefault />
                </InputLayout>

                {inputs.tipoSol === "Aplicacion de siniestros" && coberturas.length > 0 &&
                    <InputLayout className="col-12 col-md-6" label="Cobertura a solicitar">
                        <InputSelect name={names.cobertura} value={inputs.cobertura} feedback={errors.cobertura} onChange={handleCoberturaChange} onBlur={handleBlur} options={coberturas} addDefault />
                    </InputLayout>
                }

                {segurosSeleccionados.length > 0 &&
                <div className="col-12">
                    <h5>Prestamo(s) y seguro(s) seleccionados:</h5>
                    <ul>
                        {segurosSeleccionados.map((s, index) => (
                            <li key={index}>
                                Prestamo #{s.prestamo} - {s.seguro}
                                {s.medioDevo && <> - Medio: {s.medioDevo}</>} { /*(@#)1-A*/}
                                {s.nroCuenta && <> / Cta: {s.nroCuenta}</>} { /*(@#)1-A*/}
                                {inputs.tipoSol === "Aplicacion de siniestros" && s.cobertura && (
                                    <> - Cobertura: {s.cobertura}</>
                                )}
                                <button
                                    type="button"
                                    onClick={() => handleEliminarSeguro(s)}
                                    className="btn btn-danger btn-sm ml-2"
                                >
                                    Eliminar
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>         
                }                 
               
                <InputLayout className="col-12" label="Descripcion de la solicitud"> 
                    <InputText name={names.detalle} value={inputs.detalle} feedback={errors.detalle} onChange={handleChange} onBlur={handleBlur} rows={4} max={800} />
                </InputLayout>

                {/*(@#)2-A inicio*/} 
                <InputLayout className="col-12" label="Solucion Esperada">
                    <InputText name={names.solucion} value={inputs.solucion} feedback={errors.solucion} onChange={handleChange} onBlur={handleBlur} rows={4} max={100} />
                </InputLayout>
                {/*(@#)2-A fin*/} 
           
                {/*<div className="col-6 col-md-4">  */}    {/*(@#)2-A*/}             
                <div className="col-6 col-md-8">      {/*(@#)2-A*/}             
                        <label htmlFor="fichero" className="FinancieraForm-labelFiles"> Adjuntar documento(s)</label>
                        <input id="fichero" type="file" multiple onChange={(e) => subirArchivos(e.target.files)} className="FinancieraForm-inputFiles" /> 
                   
                    {archivos.length > 0 && (
                        <div className="pt-1">
                            <small><b>{archivos.length} documento(s) cargado(s)</b></small>
                            {/*(@#)2-A inicio*/}
                            <ul style={{ marginTop: "8px" }}>
                                {archivos.map((file, index) => (
                                    <li key={file.name + file.lastModified} style={{
                                        display: "flex",
                                        alignItems: "center", 
                                        gap: "8px",
                                        width: "100%",
                                        listStyle: "none"
                                    }}
                                    >
                                        <span
                                            style={{
                                                flexBasis: "90%",     
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}
                                        >
                                            - {file.name}
                                        </span>
                                        <button
                                            type="button"
                                            onClick={() => eliminarArchivo(index)}
                                            className="btn btn-danger btn-sm ml-2"
                                            style={{ flexBasis: "10%", flexShrink: 0 }}
                                        >
                                            Eliminar
                                        </button>
                                    </li>
                                ))}
                            </ul>
                            {/*(@#)2-A fin*/}
                        </div>
                    )}                    
                </div>              
               
            </FormSection>
            
            <div className="FinancieraForm-Enviar py-4">
                <button type="button" className="btn btn-primary btn-block" onClick={() => handleSend()} disabled={result.procesing}>
                    <b>{result.procesing ? 'Enviando ...': 'Enviar'}</b>
                </button>
            </div>
           
        </form>
    );
};

export default FinancieraForm;